import { Injectable, Injector, inject } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { OnAppInit } from '@frontend/vanilla/core';

import { RewardTokensDataService } from '../../betslip/modules/reward-tokens/services/reward-tokens-data.service';
import { RewardTokensContainerComponent } from './reward-tokens-container.component';

@Injectable({
    providedIn: 'root',
})
export class RewardTokenWidgetRegistration implements OnAppInit {
    private widgetRegistry = inject(WidgetRegistryService);
    private injector = inject(Injector);

    private rewardTokensDataService = inject(RewardTokensDataService);

    onAppInit(): void {
        // start fetching tokens
        this.rewardTokensDataService.init();
        this.widgetRegistry.registerLazy(WidgetType.PromoBanner, RewardTokensContainerComponent, this.injector);
    }
}
